import { Component, Input } from '@angular/core';
import { CommonModule, DecimalPipe } from '@angular/common';
import { CellRenderer, CellRendererParams } from 'app/shared/components/smart-grid/core/interfaces/cell-renderer.interface';
import { MonedaPipe } from 'app/pipes/moneda.pipe';

@Component({
    selector: 'app-sums-resume-cell-renderer',
    standalone: true,
    imports: [CommonModule, DecimalPipe, MonedaPipe],
    template: `
                                                {{value | moneda}}
  `,
})
export class SumsResumeCellRendererComponent implements CellRenderer<any> {
    @Input() params!: CellRendererParams<any>;

    get value() {
        if(this.params?.sum === 'sumSoldQuantity'){
            return this.params?.data?.sumSoldQuantity ?? 0;
        } else if(this.params?.sum === 'sumStockConfirmedERP'){
            return this.params?.data?.sumStockConfirmedERP ?? 0;
        } else if(this.params?.sum === 'sumInvoiceQuantity'){
            return this.params?.data?.sumInvoiceQuantity ?? 0;
        }   else if(this.params?.sum === 'sumDeliveredQuantity'){ 
            return this.params?.data?.sumDeliveredQuantity ?? 0;
        } else if(this.params?.sum === 'lostSale'){
            return this.params?.data?.lostSale ?? 0;
        }
    }
}
